export default function StateBlockModal({ usersState }) {

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <div style={{
        backgroundColor: 'white',
        color: 'black',
        padding: '20px',
        borderRadius: '5px',
        textAlign: 'center',
        maxWidth: '95%',
      }}>
        <h2 style={{ fontSize: '40px' }} ><i className="fa-solid fa-lock"></i></h2>
        <p>Unfortunately play is not available in {usersState}.</p>
        <p>Check back in the future for potential availability.</p>
        <p>If this is not your State, please <a style={{color: '#ce2424'}} href="/contact">let us know.</a></p>
      </div>
    </div>
  );
};